import React from 'react';

import './App.css';
import VirtualRouter from './VirtualRouter';
import { RecoilRoot } from 'recoil';
import { Toast } from '@webtoontoday/toast';

function App({isClient = false, injectedLocation = undefined}: {isClient?: boolean, injectedLocation?: string} = {isClient: false, injectedLocation: "/"}) {

    const props = {isClient, injectedLocation};
    
    return (
        <RecoilRoot>
            <div className="App" >
                <VirtualRouter {...props} />
            </div>
            <Toast />
        </RecoilRoot>
    );
}

export default App;
